export { default } from './CollapsibleExample';
